import * as Yup from 'yup';

function addStandardTeamValidation() {
  const schema = Yup.object().shape({
    firstName: Yup.string().required('Team  Name is required'),
  });
  return schema;
}
export { addStandardTeamValidation };
